import type { ApiModels } from '@ori/static-api-client';
import useSWR from 'swr';

import { useConfiguration } from '../contexts/configurationContext';
import type { ApiError } from '../models/ApiError';
import type { FetcherOptions } from '~/shared/types/FetcherOptions';
import { getSafeUrl } from '~/shared/utils/getSafeUrl';

export function useLocalizations() {
  const { tenant, staticApiUrl, currentLanguage } = useConfiguration();

  const url = getSafeUrl(
    `/tenants/${tenant}/applications/subscriptionWizard/localization`,
    staticApiUrl,
  );
  const options: FetcherOptions = {
    tenant,
    headers: { 'Accept-Language': currentLanguage },
  };

  return useSWR<ApiModels.StaticApplicationsSharedLocalizationDto, ApiError>([url, options]);
}
